import(/* webpackMode: "eager", webpackExports: ["BlogCarousel"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDL-Website\\src\\components\\BlogCarousel.tsx");
